import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
	root: {},
	cardHeader: {
		paddingBottom: 0,
	},
}));
